module.exports = __webpack_public_path__ + "static/img/2c.c09755b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/2c.jpg
// module id = XvnJ
// module chunks = 1